export enum EPrices {
  CPM = 'CPM',
  CPC = 'CPC',
  CPE = 'CPE',
  CPV = 'CPV',
}
